import { render } from "./labresultreview.vue?vue&type=template&id=cb2fe480&scoped=true"
import script from "./labresultreview.js?vue&type=script&lang=js"
export * from "./labresultreview.js?vue&type=script&lang=js"

import "./labresultreview.vue?vue&type=style&index=0&id=cb2fe480&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2fe480"]])

export default __exports__